
import { Base } from '../base-component';
import './detailed-product-card.component.scss';

export class DetailedProductCard extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}
}


// WEBPACK FOOTER //
// ./components/detailed-product-card/detailed-product-card.component.ts